var _linearGradient, _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCgma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f33f5e"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.954,
    cy: 31.934,
    fill: "url(#gradient)",
    rx: 27.673,
    ry: 27.125,
    className: "color666565 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.271,
    cy: 41.605,
    r: 0.873,
    fill: "#000",
    className: "colorFFF svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.842,45.1c0-0.484-0.392-0.873-0.873-0.873h-9.605c-0.482,0-0.874-0.393-0.874-0.875V20.648 c0-0.482,0.391-0.874,0.874-0.874h3.493c0.482,0,0.873-0.39,0.873-0.873c0-0.483-0.391-0.874-0.873-0.874h-3.493 c-1.445,0-2.62,1.175-2.62,2.62v22.703c0,1.445,1.175,2.621,2.62,2.621h9.605C24.45,45.973,24.842,45.58,24.842,45.1z",
    className: "colorFFF svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M49.081,38.102c0-0.559-0.452-1.01-1.01-1.01H13.738c-0.556,0-1.009,0.451-1.009,1.01s0.453,1.01,1.009,1.01 h34.333C48.629,39.111,49.081,38.66,49.081,38.102z",
    className: "colorFFF svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M47.545 18.029h-3.492c-.482 0-.873.391-.873.874 0 .482.391.873.873.873h3.492c.481 0 .873.391.873.873v22.703c0 .482-.392.875-.873.875H27.461c-.481 0-.872.389-.872.873v3.49c0 .482-.392.873-.874.873h-.873c-.482 0-.873.391-.873.875 0 .482.391.873.873.873h12.225c.482 0 .874-.391.874-.873 0-.484-.392-.875-.874-.875h-.872c-.482 0-.873-.391-.873-.873v-2.617h12.224c1.445 0 2.62-1.176 2.62-2.621V20.648C50.165 19.204 48.99 18.029 47.545 18.029zM28.174 49.465c.098-.275.161-.564.161-.873v-2.619h5.239v2.619c0 .309.063.598.16.873H28.174zM21.349 35.512c.482 0 .873-.389.873-.873V22.171c0-.819.229-1.619.664-2.313l2.222-3.555h1.214l2.223 3.555c.16.256.282.53.385.811h-4.96c-.482 0-.874.391-.874.873 0 .483.391.873.874.873h5.24v12.224c0 .484.391.873.872.873.482 0 .873-.389.873-.873V22.171c0-1.148-.32-2.267-.929-3.24l-3.569-5.712c-.316-.573-1.157-.573-1.48 0l-3.569 5.712c-.608.972-.93 2.092-.93 3.24v12.467C20.476 35.123 20.867 35.512 21.349 35.512z",
    className: "colorFFF svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.589 34.621v-9.606c0-.483-.392-.874-.874-.874-.481 0-.873.391-.873.874v9.606c0 .482.392.873.873.873C26.197 35.494 26.589 35.104 26.589 34.621zM40.561 35.512c.481 0 .872-.389.872-.873v-1.746c0-2.41-.387-4.793-1.149-7.082-.152-.457-.645-.704-1.104-.552-.458.152-.705.646-.553 1.105.704 2.109 1.061 4.306 1.061 6.528v1.746C39.687 35.123 40.078 35.512 40.561 35.512z",
    className: "colorFFF svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.574,35.512c0.481,0,0.872-0.389,0.872-0.873v-1.746c0-0.291,0.022-0.581,0.035-0.874h2.585 c0.481,0,0.873-0.39,0.873-0.872s-0.392-0.873-0.873-0.873h-2.438c0.17-1.326,0.452-2.634,0.877-3.909l0.443-1.33h1.116 c2.408,0,4.367-1.802,4.367-4.016c0-2.826-3.316-7.33-3.665-7.855c-0.331-0.499-1.074-0.499-1.403,0 c-0.347,0.526-3.664,5.029-3.664,7.855c0,0.228,0.021,0.457,0.063,0.682c0.089,0.474,0.541,0.79,1.018,0.7 c0.475-0.088,0.788-0.543,0.699-1.017c-0.021-0.12-0.033-0.241-0.033-0.365c0-1.527,1.532-4.172,2.619-5.809 c1.086,1.636,2.62,4.279,2.62,5.809c0,1.252-1.176,2.27-2.62,2.27h-1.746c-0.376,0-0.71,0.241-0.829,0.597l-0.643,1.926 c-0.761,2.288-1.148,4.67-1.148,7.083v1.746C32.701,35.123,33.093,35.512,33.574,35.512z",
    className: "colorFFF svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.62,
    height: 1.746,
    x: 23.715,
    y: 44.227,
    fill: "#000",
    className: "colorFFF svgShape"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgma);
export default __webpack_public_path__ + "static/media/cgma.86dfedb7fcbc3e8d0b2f1e66cedd40fa.svg";
export { ForwardRef as ReactComponent };